import React, { lazy, Suspense } from 'react';

import clsx from 'clsx';
import { withStyles } from '@material-ui/core';

import {
  Magnifier,
  MOUSE_ACTIVATION,
  TOUCH_ACTIVATION,
} from 'react-image-magnifiers';
import styles from './style';

// required to configure zoom controls provided by file-viewer
import './styles.scss';
import ErrorBoundary from '../ErrorBoundary';
import { toLowerCase } from '../../utils/strings';
import { logLevelWarning } from '../../utils/loggers';
import matomo from '../../utils/matomo';
import ShowErrorMessage from '../ShowErrorMessage';
import { getOriginalDocumentPath } from '../../utils/documents';

const imageFileTypes = [
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'svg',
  'bmp',
  'ico',
];
const videoFileTypes = [
  'mp4',
  'webm',
  'ogg',
  'avi',
  'flv',
  'mkv',
  'mov',
  'wmv',
];
const BaseFileViewer = lazy(() => import('react-file-viewer'));

const FileViewer = ({
  document,
  documentData,
  fetching,
  classes,
  fileType,
  filePath,
  className,
  isConvertedFile,
  ...props
}) => {
  const onZoomClick = () => {
    matomo.clickEvent({
      category: 'Document View',
      name: 'Zoom Document',
      action: 'Read Document',
    });
  };
  if (imageFileTypes.includes(toLowerCase(fileType))) {
    return (
      <div className="image">
        <Magnifier
          className="input-position"
          imageSrc={getOriginalDocumentPath(documentData)}
          largeImageSrc={getOriginalDocumentPath(documentData)}
          mouseActivation={MOUSE_ACTIVATION.CLICK}
          touchActivation={TOUCH_ACTIVATION.TAP}
          dragToMove
          onClick={onZoomClick}
        />
      </div>
    );
  }
  if (videoFileTypes.includes(toLowerCase(fileType))) {
    return (
      <div className={classes.videoWrapper}>
        <video className={classes.videoPlayer} controls>
          <track default kind="captions" />
          <source src={filePath} type="video/mp4" />
        </video>
      </div>
    );
  }
  if (fileType === 'pdf' || isConvertedFile) {
    return (
      <ErrorBoundary onError={() => null} logLevel={logLevelWarning}>
        <div className={clsx(className, classes.container, 'document-preview')}>
          <Suspense fallback={null}>
            <BaseFileViewer fileType="pdf" filePath={filePath} {...props} />
          </Suspense>
        </div>
      </ErrorBoundary>
    );
  }
  return <ShowErrorMessage documentOriginalPath={filePath} />;
};

export default withStyles(styles)(FileViewer);
